import { render, staticRenderFns } from "./create-stockorder.vue?vue&type=template&id=93a713ee"
import script from "./create-stockorder.vue?vue&type=script&lang=ts"
export * from "./create-stockorder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports